import {ThunkAction, Action, getDefaultMiddleware} from '@reduxjs/toolkit';
import {applyMiddleware, compose, ReducersMapObject} from 'redux';
import {createInjectStore} from '../lib/reduxInjector';
import {createLogger} from 'redux-logger';

import {applicationSlice} from '../slices/application';
import {assetSlice} from '../slices/asset';
import {editorSlice} from '../slices/editor';
import {gameSlice} from '../slices/game';
import {projectSlice} from '../slices/project';
import {translationSlice} from '../slices/translation';
import {voiceSlice} from '../slices/voice';

const logger = createLogger({
  collapsed: true,
});

// Build initial reducers map
const reducers: ReducersMapObject = {
  [applicationSlice.name]: applicationSlice.reducer,
  [assetSlice.name]: assetSlice.reducer,
  [editorSlice.name]: editorSlice.reducer,
  [gameSlice.name]: gameSlice.reducer,
  [projectSlice.name]: projectSlice.reducer,
  [translationSlice.name]: translationSlice.reducer,
  [voiceSlice.name]: voiceSlice.reducer,
};

// Compose middleware similar to RTK defaults
const defaultMiddleware = getDefaultMiddleware();
if (process.env.NODE_ENV !== 'production') {
  // redux-logger is used only during development
  defaultMiddleware.push(logger as unknown as any);
}

// Enable Redux DevTools if present
const composeEnhancers =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const enhancer = composeEnhancers(applyMiddleware(...defaultMiddleware));

// Create store compatible with redux-injector (enables dynamic reducer injection used by @dized/ui)
export const store = createInjectStore(reducers, undefined as any, enhancer);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
